export const ESTIMATE = "estimate";
export const APPROVED = "approved";
export const INVOICE = "invoice";
export const PAID = "paid";

export const STATUS_OPTIONS = [
  { value: ESTIMATE, label: "Estimate" },
  { value: APPROVED, label: "Approved" },
  { value: INVOICE, label: "Invoice" },
  { value: PAID, label: "Paid" },
];

const humanizeStatus = (status) =>
  status
    .toString()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const documentNoun = (status) => {
  switch (status) {
    case PAID:     return "Invoice";
    case INVOICE:  return "Invoice";
    case APPROVED: return "Estimate";
    case ESTIMATE: return "Estimate";
    default:       return status ? humanizeStatus(status) : "Estimate";
  }
};

export const pillLabel = (status) => {
  switch (status) {
    case ESTIMATE: return "Estimate";
    case APPROVED: return "Approved";
    case INVOICE:  return "Invoice";
    case PAID:     return "Paid";
    default:       return status ? humanizeStatus(status) : "Estimate";
  }
};

export const statusBadgeClass = (status) => {
  switch (status) {
    case PAID:     return "badge-success";
    case INVOICE:  return "badge-warning";
    case APPROVED: return "badge-primary";
    default:       return "badge-secondary";
  }
};
